import { useState } from "react";

const GovernanceData = () => {
    const [disabledInputs, setDisabledInputs] = useState();

    const data = [
        {
            metric: "Board Diversity",
            question: "What was the management representation by gender (% female / % male) during the last fiscal year?",
            unit: "% female / % male",
            sector: "General",
            example: "2%"
        },
        {
            metric: "Board Diversity",
            question: "What was the management representation by gender (% female / % male) during the last fiscal year?",
            unit: "% female / % male",
            sector: "General",
            example: "68%"
        },
        {
            metric: "Board Diversity",
            question: "What was the management representation by gender (% female / % male) during the last fiscal year?",
            unit: "% female / % male",
            sector: "General",
            example: "740"
        },
        {
            metric: "Board Diversity",
            question: "What was the management representation by gender (% female / % male) during the last fiscal year?",
            unit: "% female / % male",
            sector: "General",
            example: "1080"
        },
        {
            metric: "Training & qualification",
            question: "What was the total expenses on training and qualification in relation to revenues during the last fiscal year?",
            unit: "Percentage",
            sector: "General",
            example: "40%"
        },
        {
            metric: "Training & qualification",
            question: "What was the hours on training per employee p.a during the last fiscal year?",
            unit: "Hours",
            sector: "General",
            example: "48%"
        },
        {
            metric: "Health and safety",
            question: "What was the health rate during the last fiscal year?",
            unit: "Percentage",
            sector: "General",
            example: "2021"
        }
    ];

    const toggleInput = (index) => {
  
        setDisabledInputs(index)
        if(index==disabledInputs){
            setDisabledInputs(null)
        }
      };
    return (
        <>
            <div className="socialtab">
            <table className="table">
  <thead>
    <tr>
    <th scope="col">Metric</th>
      <th scope="col">Question</th>
      <th scope="col">Inputs</th>
     <th scope="col">Unit</th>
   
    </tr>
  </thead>
  <tbody>

  {data.length > 0 ? (
              data.map((curData, index) => {
                const { question, metric, unit } = curData;

                return (
                  <tr key={index}>
                    <td>{metric}</td>
                    <td>{question}</td>
                    <td>
                      <input
                      className="removearrow"
                        type="number"
                        disabled={disabledInputs==index ? false:true}
                      />
                      <i
                        className="fa-regular fa-pen-to-square editable-inputbox"
                        onClick={() => toggleInput(index)}
                      ></i>
                    </td>
                    
                    <td>{unit}</td>
                 
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="6">No Governance reports data available.</td>
              </tr>
            )}
   
  </tbody>
</table>
            </div>
            
        </>
    )
}

export default GovernanceData;